import { useState, useEffect } from 'react';
import { BreedCard } from '@/components/BreedCard';
import { api } from '@/lib/api';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { SEO } from '@/components/SEO';

export default function EncyclopediaPage() {
  const [breeds, setBreeds] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getBreeds({ search: search || undefined })
      .then(r => setBreeds(r.data.breeds || []))
      .catch(() => setBreeds([]))
      .finally(() => setLoading(false));
  }, [search]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in" data-testid="encyclopedia-page">
      <SEO
        title="Dog Breeds Encyclopedia"
        description="Explore our comprehensive guide to dog breeds. Learn about temperaments, care needs, and find the best dog breed for your lifestyle."
        keywords="dog breeds guide, best dog breeds for apartments, family-friendly dog breeds, low maintenance dogs, hypoallergenic dogs"
      />
      <div className="mb-8">
        <h1 className="font-['Nunito'] font-extrabold text-3xl sm:text-4xl text-[#1A1D20] tracking-tight">
          Dog Breeds Encyclopedia
        </h1>
        <p className="text-sm text-[#5C636A] mt-1">
          Explore our comprehensive guide to dog breeds, temperaments, and care needs
        </p>
      </div>

      <div className="relative max-w-md mb-8">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#5C636A]" />
        <Input
          placeholder="Search breeds..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="pl-10 h-11 rounded-xl bg-white border-gray-200"
          data-testid="breed-search-input"
        />
      </div>

      {loading ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
          {[...Array(10)].map((_, i) => (
            <div key={i} className="bg-white rounded-3xl overflow-hidden animate-pulse">
              <div className="aspect-square bg-gray-200" />
              <div className="p-4 space-y-2"><div className="h-4 bg-gray-200 rounded w-3/4" /></div>
            </div>
          ))}
        </div>
      ) : breeds.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6" data-testid="breeds-grid">
          {breeds.map(breed => (
            <BreedCard key={breed.slug} breed={breed} />
          ))}
        </div>
      ) : (
        <div className="text-center py-20">
          <p className="text-[#5C636A] text-lg">No breeds found</p>
          <p className="text-sm text-[#5C636A] mt-1">Try a different search term</p>
        </div>
      )}
    </div>
  );
}
